<div class="flex gap-2" *ngIf="meeting">
  <i class="text-6 fa-kit fa-talos-calendar-alt" [ngClass]="{'text-neutral-300': disabled, 'text-neutral-400': !disabled}"></i>  
  <span class="text-4 leading-24" [ngClass]="{'text-neutral-300': disabled, 'text-dark': !disabled}" *ngIf="meeting.startDate">{{formatMeetingDate(meeting.startDate)}}</span>
  <span class="text-4 italic leading-24" [ngClass]="{'text-neutral-300': disabled, 'text-neutral-500': !disabled}" *ngIf="!meeting.startDate">Date and Time Pending Selection</span>
</div>
